export const updateUrlWithLanguage = (newLanguage: string) => {
  const url = new URL(window.location.href);
  url.searchParams.set('lang', newLanguage);
  window.location.href = url.toString();
};

export const getLanguageFromUrl = (): string | null => {
  const url = new URL(window.location.href);
  return url.searchParams.get('lang');
};
